module finadai.app.dashboard {
  export var NAME = 'finadai.app.dashboard';
  interface DashboardAction {
    name: string;
    state?: string;
    icon: string;
    permission: string;
    is_search?: boolean;
  }
  function DashboardController($scope, whoIAm: models.User, $mdDialog: ng.material.IDialogService) {
    var actions:Array<DashboardAction> =$scope.actions = [
        {
            name: 'Crear Negociación',
            is_search: false,
            state: 'app.admin.create',
            icon: 'add_circle',
            permission: 'admin_create_negotiation'
        },
        {
            name: 'Cancelar Negociación',
            is_search: false,
            state: 'app.admin.cancel_negotiation',
            icon: 'block',
            permission: 'admin_cancel_negotiation'
        },
        {
            name: 'Actualizar Datos Cliente',
            is_search: false,
            state: 'app.admin.update',
            icon: 'autorenew',
            permission: 'admin_update_customer'
        },
        {
            name: 'Buscar Cliente por ID',
            is_search: false,
            state: 'app.admin.search',
            icon: 'search',
            permission: 'admin_search_customer'
        },
        {
            name: 'Buscar Negociación por ID',
            is_search: false,
            state: 'app.admin.find_negotiation',
            icon: 'search',
            permission: 'admin_find_negotiation'
        },
        {
            name: 'Buscar Cliente por Datos',
            is_search: false,
            state: 'app.admin.find',
            icon: 'people',
            permission: 'admin_find_customer'
        },
        {
            name: 'Crear Referencia Unica',
            is_search: false,
            state: 'app.admin.create_reference',
            icon: 'receipt',
            permission: 'admin_create_single_reference'
        },
        {
            name: 'Archivo SIC',
            is_search: false,
            state: 'app.admin.change_sic',
            icon: 'dns',
            permission: 'admin_change_sic_customer'
        },
        {
            name: 'Mi perfil',
            is_search: false,
            state: 'app.customers.profile',
            icon: 'person',
            permission: 'customers_get_info'
        }
    ];
    if(whoIAm.privilege == 'customer'){
      $mdDialog.show({
        template: '<md-dialog><md-dialog-content class="md-dialog-content">' +
          '<h2 class="text-center">¡Aquí <i>tú</i> tienes el control!</h2>' +
          '<p class="text-center">Sigue los siguientes pasos:'+
          '<ol>'+
          '<li>Da click a mi perfil...</li>'+
          '<li>Revisa y actualiza tu información personal</li>' +
          '<li>Revisa la información de tu(s) crédito(s)</li>' +
          '<li>Haz tu propuesta y recibe respuesta inmediata</li>' +
          '<li>Acepta términos y condiciones</li>' +
          '</ol></p>' +
          '</md-dialog-content>' +
          '<md-dialog-actions><md-button ng-click="close()">Ok</md-button></md-dialog-actions>' +
          '</md-dialog>',
        parent: angular.element(document.body),
        clickOutsideToClose:true,
        controller: ($scope: any, $mdDialog) => {
          $scope.close = () => {
            $mdDialog.hide();
          }
        },
        fullscreen: false // Only for -xs, -sm breakpoints.
      });
      }
  }
  export function run(){
    var dashboard = angular.module(NAME, []);
    dashboard.controller('DashboardController', DashboardController)
  }
} finadai.app.dashboard.run();
